export default __webpack_public_path__ + "static/filecleanedfromorangedust-158fcd78524531cce25455f8d977e950.png";